module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="base-form js-link-account-form">\n	<h1>Link your 2017 '+
((__t=( game_title ))==null?'':_.escape(__t))+
' Account</h1>\n	<p>Please enter your old 2017 '+
((__t=( game_title ))==null?'':_.escape(__t))+
' account details to link these details with your new NRL Account.</p>\n	<div class="form-group">\n		<input type="email" id="login" name="login" class="js-login" value="'+
((__t=( login ))==null?'':_.escape(__t))+
'" placeholder="Enter 2017 registered email address">\n		';
 if (errors && errors.login) { 
__p+='\n			<div class="error">'+
((__t=( errors.login[0] ))==null?'':__t)+
'</div>\n		';
 } 
__p+='\n		<input type="password" id="password" name="password" class="js-password" value="'+
((__t=( password ))==null?'':_.escape(__t))+
'" placeholder="Enter 2017 registered password">\n		';
 if (errors && errors.password) { 
__p+='\n			<div class="error">'+
((__t=( errors.password[0] ))==null?'':__t)+
'</div>\n		';
 } 
__p+='\n		<button type="button" class="btn-text under-field-text js-forgot-password">Forgot 2017 registered password</button>\n		';
 if (errors && errors.server_side) { 
__p+='\n			<div class="error">'+
((__t=( errors.server_side[0] ))==null?'':__t)+
'</div>\n		';
 } 
__p+='\n	</div>\n\n	<p>This means in future you will use your new NRL Account as your '+
((__t=( game_title ))==null?'':_.escape(__t))+
' login, but all of your previous team and league history will be retained.</p>\n	<div class="buttons-wrapper">\n		<button type="button" class="btn secondary-btn js-cancel">Cancel</button>\n		<button type="submit" class="btn primary-btn js-link">Link</button>\n	</div>\n</form>\n';
}
return __p;
};
